import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Button, Card, Input, Label } from "../components/ui";
import { toast } from "sonner";

export default function LoginPage() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const r = await login(email, password);
    setLoading(false);
    if (r.ok) { toast.success("Accesso effettuato"); nav("/"); }
    else toast.error(r.error || "Credenziali non valide");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-app px-4">
      <Card className="w-full max-w-md p-8">
        <div className="mb-6">
          <div className="font-display text-2xl font-bold tracking-tight">Bridge ZF</div>
          <div className="text-sm text-ink-muted">Pannello amministrativo</div>
        </div>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required value={email}
                   onChange={(e) => setEmail(e.target.value)}
                   data-testid="login-email" autoFocus />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" required value={password}
                   onChange={(e) => setPassword(e.target.value)}
                   data-testid="login-password" />
          </div>
          <Button type="submit" className="w-full" disabled={loading} data-testid="login-submit">
            {loading ? "Accesso..." : "Accedi"}
          </Button>
        </form>
        <p className="mt-6 text-xs text-ink-subtle text-center">
          Accesso riservato. Tutte le azioni sono registrate.
        </p>
      </Card>
    </div>
  );
}
